export const breakpointMobileSmall = "320px";
export const breakpointMobileLarge = "375px";
export const breakpointTabletSmall = "768px";
export const breakpointTabletLarge = "1024px";
export const breakpointDesktopSmall = "1280px";
export const breakpointDesktopMedium = "1440px";
export const breakpointDesktopLarge = "1920px";